import { ca } from '@cian/analytics';

export const trackShowOnMapTagClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BuildingProgress_JK',
    pageType: 'BuildingProgressJK',
    action: 'tag_click',
    label: 'show_on_map',
  });
};
